// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","form":"form-bqBmR","formControl":"formControl-2ALqx","label":"label-1sO5L","checkbox":"checkbox-134U7"};